import { Menu } from "lucide-react";
import { useNavigation } from "react-router";

import { selectCurrentUser } from "@/features/auth";
import { NotificationBellDropdown } from "@/features/notificacoes/components/NotificationBellDropdown";
import { UserAvatar } from "@/shared/components/UserAvatar";
import { useAppSelector } from "@/shared/store/hooks";

import { Breadcrumb } from "./Breadcrumb";

interface TopbarProps {
  onMenuOpen?: () => void;
}

export function Topbar({ onMenuOpen }: TopbarProps) {
  const navigation = useNavigation();
  const isNavigating = navigation.state === "loading";
  const user = useAppSelector(selectCurrentUser);
  const nome = user?.nome ?? "Usuário";
  const email = user?.email ?? "";
  const initials = nome
    .split(" ")
    .slice(0, 2)
    .map((p) => p[0])
    .join("")
    .toUpperCase();

  return (
    <header className="relative flex h-[63px] flex-shrink-0 items-center justify-between border-b border-gray-200 bg-white px-5">
      {isNavigating && (
        <div className="absolute inset-x-0 top-0 h-0.5 overflow-hidden">
          <div className="h-full w-full origin-left animate-nav-progress bg-[var(--color-brand-secondary-200)]" />
        </div>
      )}
      {/* Left side — botão mobile + breadcrumb */}
      <div className="flex min-w-0 items-center gap-3">
        <button
          className="rounded p-1 transition-colors hover:bg-gray-100 md:hidden"
          aria-label="Abrir menu"
          onClick={onMenuOpen}
        >
          <Menu size={20} color="#4a5565" />
        </button>
        <Breadcrumb />
      </div>

      {/* Right side — ações globais */}
      <div className="flex items-center gap-3">
        <NotificationBellDropdown />
        <UserAvatar initials={initials} name={nome} email={email} />
      </div>
    </header>
  );
}
